<template>
  <div class="container">
    <div class="row">
      <div class="ourIngredients-container">
        <div
          v-for="ingredientsInfo in option.ingredientsdetail"
          :key="ingredientsInfo.title"
          class="detail-container col-md-4"
        >
          <div class="bottom-container">
            <div class="category-image" @click="navigateTo(ingredientsInfo.anchor)">
              <a :href="ingredientsInfo.anchor">
                <img
                  :title="ingredientsInfo.title"
                  :src="ingredientsInfo.imageurl"
                  :alt="ingredientsInfo.alt"
                />
              </a>
            </div>
            <div data-ioplist="">
              <h4>{{ ingredientsInfo.tabname }}</h4>
            </div>
            <p class="subtitle">{{ ingredientsInfo.subtitle }}</p>
            <div data-ioplist="">
              <p v-shave="{ height: 90 }" v-html="ingredientsInfo.description"></p>
            </div>
            <div
              class="btn-container"
              @click="
                ctadatalayer(
                  ingredientsInfo.tabname,
                  ingredientsInfo.ctabuttontext,
                  ingredientsInfo.anchor,
                )
              "
            >
              <a :href="ingredientsInfo.anchor" role="button" class="">
                <strong>{{ ingredientsInfo.ctabuttontext }}</strong>
              </a>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'our-ingredients',
  props: {
    option: {
      type: Object,
      required: true,
    },
  },

  methods: {
    navigateTo(url) {
      window.location.href = url;
    },
    ctadatalayer(tabname, ctabuttontext, anchor) {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'content page',
        eventAction: `select::${tabname}`,
        eventLabel: `${ctabuttontext}::${anchor}`,
        ecommerce: 'undefined',
        event_name: 'body_button_click',
        module_name: tabname,
        cta_name: ctabuttontext,
        link_url: anchor,
      });
    },
  },
};
</script>
